import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Admin from 'apis/Admin';
import { mapKeys } from 'lodash';

// First, create the thunk
export const userRequest = createAsyncThunk(
  'userList',
  async ({ data, start, limit }) => {
    const response = await Admin.post(`allUsers/${start}/${limit}`, data);
    return response.data.data;
  }
);

// User Account Control
export const userAccountControlRequest = createAsyncThunk(
  'userControl',
  async ({ data }) => {
    await Admin.post('user/accountControl', data);
    return data;
  }
);

// Move to Pending User
export const pendingUserRequest = createAsyncThunk(
  'pendingUser',
  async ({ data }) => {
    await Admin.post('updateUserStatus', data);
    return data;
  }
);

// Upload Identity Proof
export const uploadIdentityProofRequest = createAsyncThunk(
  'uploadIdentityProof',
  async ({ data, func }) => {
    await Admin.post('identityProof', data);
    if (func) {
      await func();
    }
    return data;
  }
);

// Then, handle actions in your reducers:
const userSlice = createSlice({
  name: 'user',
  initialState: { userList: [], totalList: '', message: '', loading: false },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [userRequest.fulfilled]: (state, action) => {
      // Add key to the state array
      console.log(action, "userRequest");
      return {
        ...state,
        userList: { ...mapKeys(action.payload.users, '_id') },
        totalList: action.payload.totalUsers,
        message: action.payload.message,
        loading: false,
      };
    },
    [userRequest.pending]: state => {
      return { ...state, loading: true };
    },
    [userRequest.rejected]: (state, action) => {
      return {
        ...state,
        userList: action.payload,
        message: 'no data',
        loading: false,
      };
    },
    [userAccountControlRequest.fulfilled]: (state, action) => {
      switch (action.payload.type) {
        case 1:
          return {
            ...state,
            userList: {
              ...state.userList,
              [action.payload.users[0]]: {
                ...state.userList[action.payload.users[0]],
                loginType: 1,
              },
            },
            loading: false,
          };
        case 2:
          return {
            ...state,
            userList: {
              ...state.userList,
              [action.payload.users[0]]: {
                ...state.userList[action.payload.users[0]],
                loginType: 2,
              },
            },
            loading: false,
          };
        case 3:
          return {
            ...state,
            userList: {
              ...state.userList,
              [action.payload.users[0]]: {
                ...state.userList[action.payload.users[0]],
                status: true,
                isVerified: true,
              },
            },
            loading: false,
          };
        case 4:
          return {
            ...state,
            userList: {
              ...state.userList,
              [action.payload.users[0]]: {
                ...state.userList[action.payload.users[0]],
                status: false,
              },
            },
            loading: false,
          };
        default:
          return {
            ...state,
          };
      }

    },
    [userAccountControlRequest.pending]: state => {
      return { ...state, loading: true };
    },
    [userAccountControlRequest.rejected]: state => {
      return {
        ...state,
        message: 'no data',
        loading: false,
      };
    },
    [pendingUserRequest.pending]: state => {
      return { ...state, loading: true };
    },
    [pendingUserRequest.rejected]: state => {
      return {
        ...state,
        loading: false,
      };
    },
    [pendingUserRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        message: action.payload.message,
        loading: false,
      };
    },
    [uploadIdentityProofRequest.pending]: state => {
      return { ...state, loading: true };
    },
    [uploadIdentityProofRequest.rejected]: state => {
      return {
        ...state,
        loading: false,
      };
    },
    [uploadIdentityProofRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        message: action.payload.message,
        loading: false,
      };
    },
  },
});

export default userSlice.reducer;
